import React from 'react';
import { Box, Stack } from '@mui/material';

import { DynamicCard, DynamicCardAccessory, DynamicCardContent, DynamicCardMedia } from '../DynamicCard';
import { SurgeonWarning } from '../SurgeonWarning/SurgeonWarning';
import { SizingMultiplier } from '../../theme/constants';
import { ExternalOfferTitle } from './components/ExternalOfferTitle';
import { ExternalOfferContent } from '../../modules/external-loyalty/external-offers.types';
import { CouldBeUnavailableNearby } from './components';

export type ExternalOfferCardProps = {
  onClick?: () => void;
  content: ExternalOfferContent;
  shouldShowUnavailableWarning?: boolean;
};

export const ExternalOfferCard = React.forwardRef<HTMLDivElement, ExternalOfferCardProps>(
  (props: ExternalOfferCardProps, ref) => {
    const {
      content: { title, titleMiddle, title2, imageUrl, surgeonGeneralWarning },
      shouldShowUnavailableWarning,
      onClick,
    } = props;
    return (
      <DynamicCard ref={ref} loading={false} disabled={false} onClick={onClick}>
        {surgeonGeneralWarning && (
          <Box
            sx={(theme) => ({
              m: theme.spacing(SizingMultiplier.md, SizingMultiplier.md, -SizingMultiplier.sm),
            })}>
            <SurgeonWarning message={surgeonGeneralWarning} />
          </Box>
        )}
        <Box position="relative">
          <DynamicCardContent>
            {imageUrl && <DynamicCardMedia src={imageUrl} alt={title} objectFit="contain" />}

            <Stack
              direction="column"
              spacing={SizingMultiplier.sm}
              flex={1}
              alignItems="flex-start"
              justifyContent="center">
              <ExternalOfferTitle title={title} titleMiddle={titleMiddle} title2={title2} />

              {shouldShowUnavailableWarning && <CouldBeUnavailableNearby />}
            </Stack>
            <DynamicCardAccessory type="disclosureIndicator" />
          </DynamicCardContent>
        </Box>
      </DynamicCard>
    );
  },
);
